<template>
    <b-card>
        <div class="container-fluid" style="max-width: 500px">
            <b-row>
                <b-col class="text-center">
                    <h5 class="text-uppercase" v-text="_trans('Limitations for business models')"></h5>
                    <h6 v-text="_trans('Define limitations for variant options')"></h6>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-btn :disabled="!catalogs.selected" @click="$refs.xlsxInput.click()">
                        <span v-text="_trans('Import CLimits')"></span>
                    </b-btn>
                </b-col>
                <b-col>
                    <b-btn :disabled="!catalogs.selected" @click="exportClimitsDataFromXLSX">
                        <span v-text="_trans('Export CLimits')"></span>
                    </b-btn>
                </b-col>
            </b-row>
            <b-row v-if="enableCatalogList" class="mt-4">
                <b-col class="text-center">
                    <h6 v-text="_trans('Selected catalog:')"></h6>
                    <b-form-select v-if="catalogs.list.length > 1" v-model="catalogs.selected">
                        <option v-for="opt in catalogs.list" :key="opt.cod" :value="opt.cod" v-text="opt.des" />
                    </b-form-select>
                    <template v-else-if="catalogs.selected && catalogs.selected.des">
                        <span v-text="_trans('Catalog provided:')" />
                        <strong v-text="catalogs.selected.des" />
                    </template>
                    <!--<pre>{{ catalogs }}</pre>-->
                </b-col>
            </b-row>
            <input v-show="false" :key="XLSXimportExportConfig.counter" ref="xlsxInput" type="file" @input="importClimitsDataFromXLSX($refs.xlsxInput.files && $refs.xlsxInput.files.length > 0 ? $refs.xlsxInput.files[0] : null)" />
            <!--
            <div>
                defaultCatalog: {{ defaultCatalog }}
                <pre>{{ selectedCatalogData }}</pre>
            </div>
            -->
        </div>
    </b-card>
</template>

<script>
    import * as DataURIs from "@/DataURIs";
    import { CsearchAPI } from "@3cad/nextcore";
    import { CustomerExtendedApiClient } from "@custom/classes/CustomerExtendedApiClient";
    import { bus } from "@store/dau";

    export default {
        name: "Utilities",
        data() {
            return {
                enableCatalogList: true,
                enableCatalogCod: false,
                catalogs: {
                    selected: null,
                    list: []
                },
                hiddenCatalogs: ["PARETI", "PARETI_3CADNEXT"],
                XLSXimportExportConfig: {
                    loading: false,
                    counter: 0
                }
            };
        },
        computed: {
            config() {
                return this.$store.getters["getConfig"];
            },
            defaultCatalog() {
                if (this.user.catalog) return this.user.catalog;
                else if (this.config.forcedcatalog !== "") return this.config.forcedcatalog;
                else return null;
            },
            selectedCatalogData() {
                if (this.catalogs.selected) {
                    return this.catalogs.list.find(itm => itm.cod === this.catalogs.selected);
                } else {
                    return {
                        cod: null,
                        des: null,
                        img: null,
                        imgbig: null,
                        tip: "C",
                        local: 0
                    };
                }
            }
        },
        created() {
            this.onCreated();
        },
        methods: {
            onCreated() {
                this.getCatalogs();
            },
            async getCatalogs() {
                let getCatalogs = async () => {
                    return new Promise((resolve, reject) => {
                        bus.$emit("startLoading");
                        CsearchAPI.getCatalogs(
                            json => {
                                bus.$emit("stopLoading");
                                resolve(json);
                            },
                            error => {
                                bus.$emit("stopLoading");
                                console.error(error);
                                reject(error);
                            }
                        );
                    });
                };
                let catalogs = await getCatalogs();
                if (catalogs) {
                    this.catalogs.list = catalogs.filter(itm => this.hiddenCatalogs.indexOf(itm.cod.toUpperCase()) === -1);
                    if (this.defaultCatalog) {
                        this.catalogs.selected = catalogs.find(itm => itm.cod === this.defaultCatalog).cod;
                    }
                }
            },
            importClimitsDataFromXLSX(file) {
                if (this.catalogs.selected) {
                    let catalog = this.selectedCatalogData.cod;
                    this.$3cadAsk({
                        title: this._trans("Import Climits from .xlsx"),
                        body: this._trans("Do you wish to replace existing data?"),
                        okTitle: this._trans("Yes"),
                        cancelTitle: this._trans("No")
                    })
                        .then(data => {
                            // YES
                            this.importClimits(catalog, file, true);
                        })
                        .catch(mode => {
                            if (mode === 0) {
                                // NO
                                this.importClimits(catalog, file, false);
                            }
                        });
                } else {
                    console.warn(this._trans("Catalog not provided"));
                }
            },
            exportClimitsDataFromXLSX() {
                if (this.catalogs.selected) {
                    let catalog = this.selectedCatalogData.cod;
                    let catalogName = this.selectedCatalogData.des;
                    catalogName = catalogName.replaceAll(" ", "_");
                    let filename = `Catalog_${catalogName}_limits.xlsx`;
                    bus.$emit("startLoading");
                    const _this = this;
                    CustomerExtendedApiClient.exportClimitsDataFromXLSX(
                        catalog,
                        res => {
                            let dataurl = res;
                            DataURIs.download(dataurl, filename);
                            bus.$emit("stopLoading");
                            _this.XLSXimportExportConfig.counter++;
                        },
                        err => {
                            bus.$emit("stopLoading");
                            _this.XLSXimportExportConfig.counter++;
                            console.error(err);
                        }
                    );
                } else {
                    console.warn(this._trans("Catalog not provided"));
                }
            },
            importClimits(catalog, file, replaceData) {
                bus.$emit("startLoading");
                CustomerExtendedApiClient.importClimitsDataFromXLSX(
                    catalog,
                    file,
                    replaceData,
                    res => {
                        bus.$emit("stopLoading");
                        this.XLSXimportExportConfig.counter++;
                        let message = res.error ? res.error.ex("\n", 1) : this._trans(res.body);
                        this.$3cadInfo({
                            title: this._trans("Import Climits from .xlsx"),
                            body: message
                        });
                    },
                    err => {
                        bus.$emit("stopLoading");
                        this.XLSXimportExportConfig.counter++;
                        console.error(err);
                    }
                );
            }
        }
    };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/custom/giorgetti/pages/utilities.vue